import { render } from "./pushMaterial.vue?vue&type=template&id=a19e85b0&scoped=true"
import script from "./pushMaterial.vue?vue&type=script&lang=js"
export * from "./pushMaterial.vue?vue&type=script&lang=js"

import "./pushMaterial.vue?vue&type=style&index=0&id=a19e85b0&scoped=true&lang=scss"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a19e85b0"]])

export default __exports__